<template>
  <v-tooltip bottom :disabled="tooltip === ''">
    <template v-slot:activator="{ on: btn_tooltip }">
      <v-btn
        v-show="show"
        v-bind="$attrs"
        :color="color"
        :class="customClass"
        elevation="0"
        min-width="0"
        :small="!dynamic"
        :text="text"
        v-on="{ ...btn_tooltip, ...$listeners }"
        @click="click"
      >
        {{ !dynamic_show ? $t(title) : '' }}
        <v-icon
          v-if="dynamic_show"
          dark
        >
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ $t(tooltip) }}</span>
  </v-tooltip>
</template>

<script>

  export default {
    name: 'TooltipBtn',

    props: {
      icon: {
        type: String,
        default: '',
      },
      tooltip: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      dynamic: {
        type: Boolean,
        default: false,
      },
      text: {
        type: Boolean,
        default: true,
      },
      show: {
        type: Boolean,
        default: true,
      },
      color: {
        type: String,
        default: '',
      },
      customClass: {
        type: String,
        default: 'px-0 ml-1',
      },
    },
    computed: {
      dynamic_show () { return this.dynamic ? this.$vuetify.breakpoint.xs : true },
    },
    methods: {
      click () {
        // console.log('click')
        // return this.$emit('click')
      },
    },
  }
</script>
